<template>
    <div class="competition_wrap pb17">
        <div class="competition_item thumbnail_item mypage_filter_item">
            <div class="competition_input">
                <el-input :placeholder="$t('st')" v-model="searchInput"
                          @input="setData('searchInput',searchInput)"
                          @keypress.native.enter="setFilterFunc(searchInputOption,searchInput)"/>
                <button class="competition_btn"  @click="setFilterFunc(searchInputOption,searchInput)"></button>
            </div>
        </div>
        <div class="competition_btn_wrap">
            <button class="c_filter_btn" @click="openFilter('item-filter-open-my-filter')"></button>
            <!--썸네일 원 아이콘-->
            <button class="c_filter_thumnail_btn btn_thumb_one"
                    v-show=" listChange === 'thumbnail_one'"
                    @click="listTypeChange('thumbnail_two')"></button>
            <!--썸네일 투 아이콘      -->
            <button class="c_filter_thumnail_btn"
                    v-show=" listChange === 'thumbnail_two'"
                    @click="listTypeChange('thumbnail_one')"></button>
        </div>
        <item-filter-open-my-filter></item-filter-open-my-filter>
    </div>
<!--    <div class="search_item mb19">
        <div class="filter_category_box mr5">
            <el-select id="category" v-model="searchInputOption" class="my_filter select"
                       popper-class="select_style"
                       :popper-append-to-body="false"
            >
                <el-option :value="'ina'" :label="$t('subject')"></el-option>
                <el-option :value="'hash'" :label="$t('hashtag')"></el-option>
                <el-option :value="'orni'" :label="$t('k_creator')"></el-option>
                <el-option :value="'prni'" :label="$t('owner')"></el-option>
                <el-option :value="'cuni'" :label="$t('curator')"></el-option>
            </el-select>
        </div>
        <div class="search_input mypage_search_input">
            <el-input :placeholder="$t('st')" v-model="searchInput"
                      @input="setData('searchInput',searchInput)"
                      @keyup.native.enter="setFilterFunc(searchInputOption,searchInput)">
            </el-input>
            <button class="search_btn mypage_search_btn" @click="setFilterFunc(searchInputOption,searchInput)">
            </button>
        </div>
        <button class="search_filter_btn" @click="openFilter('item-filter-open-my-filter')"></button>
        <item-filter-open-my-filter></item-filter-open-my-filter>
    </div>-->
</template>

<script>
import itemUtil from "@/components/item/itemUtil";
import util from "@/mixins/util";
import ItemFilterOpenMyFilter from "@/components/filter/ItemFilterOpenMyFilter";
import EventBus from "@/utils/event-bus";

const {filterConfig} = itemUtil
export default {
    name: "ItemFilterOpenMyLayout",
    mixins: [itemUtil],
    components: {ItemFilterOpenMyFilter},
    inject: ['setFilter', 'setSort'],
    provide() {
        return {}
    },
    props: {
        filterData: {
            default: () => {
            }
        },

    },
    data() {
        return {
            searchInputOption: 'ina',
            searchInput: '',
            filterCategory: [],
            filterStatus: [],
            filterCuration: [],
            filterEdition: [],
            filterType: [],
            statusArr: [],
            listChange: 'thumbnail_one',
        }
    },
    beforeRouterEnter() {
    },
    created() {
        this.setterFilterDataInData();
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        openFilter(name) {
            this.$modal.show(name, {filterData: this.filterData});
        },
        setterFilterDataInData() {
            let classnames = Object.keys(this.filterData);
            classnames.forEach(classname => {
                let obj = this.filterData[classname];
                let type = filterConfig[obj.key].type;
                if (this.hasOwnProperty(classname)) {
                    if (type == 'query') {
                        this[classname] = obj.query;
                        if (this.hasOwnProperty(classname + 'Option')) {
                            this[classname + 'Option'] = obj.key;
                        }
                    } else if (type === 'between') {
                        this[classname] = [obj.start, obj.end];
                    } else if (type === 'match') {
                        if (isNaN(obj.value)) {
                            this[classname] = obj.value;
                        } else {
                            this[classname] = Number(obj.value);
                        }

                    } else if (type === 'terms') {
                        this[classname] = obj.terms;
                    }

                }
            })
        },
        listTypeChange(type) {
            this.listChange = type;
            EventBus.$emit('changeListType', type);
        },
        setFilterFunc(key, value) {
            this.setFilter(key, value);
        },
        setData(key, value) {
            this[key] = value;
        },

    },
    watch: {},
}
</script>

<style scoped>

</style>
